import { BOOKING_STATUSES, ENQ_STATUSES } from "@/lib/constants";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-navy tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const StatusBadge = ({ status, kind = "enquiry", testId }) => {
  const list = kind === "booking" ? BOOKING_STATUSES : ENQ_STATUSES;
  const s = list.find((x) => x.value === status) || list[0];
  return <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>{s.label}</span>;
};

export const Panel = ({ children, className = "", ...props }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white ${className}`} {...props}>{children}</div>
);

export const Empty = ({ children, testId }) => (
  <div className="py-16 text-center text-sm text-slate-500" data-testid={testId}>{children}</div>
);

export const marginCls = (m) => (m >= 15 ? "text-emerald-600" : m >= 5 ? "text-amber-600" : "text-rose-600");
